import ApiService from '../global/services/api.service';
import {
  DailyWorkdayDurationFilters,
  DailyWorkdayDurationReportDTO,
} from '../reports/modules/dailyWorkdayDuration/types';
import {
  VisitedLocationsFilters,
  VisitedLocationsReportDTO,
} from '../reports/modules/visitedLocations/types';
import {
  ConditionalEventsFilters,
  ConditionalEventsReportDTO,
} from '../reports/modules/conditionalEvents/types';
import { TripsFilters, TripsReportDTO } from '../reports/modules/trips/types';

import { ReportType } from '../reports/types';
import {
  VehicleGeofenceFilters,
  VehicleGeofenceReportDTO,
} from '../reports/modules/vehicleGeofence/types';

class ReportService {
  static ENDPOINT = '/reports';

  static getReportTypes() {
    return ApiService.get<ReportType[]>(`${ReportService.ENDPOINT}/types`);
  }

  static getVisitedLocationsReport(filters: VisitedLocationsFilters) {
    return ApiService.post<VisitedLocationsReportDTO>(
      `${ReportService.ENDPOINT}/${ReportType.VISITED_LOCATIONS}`,
      filters,
    );
  }

  static getDailyWorkdayDurationReport(filters: DailyWorkdayDurationFilters) {
    return ApiService.post<DailyWorkdayDurationReportDTO>(
      `${ReportService.ENDPOINT}/${ReportType.WORKDAY_DURATION}`,
      filters,
    );
  }

  static getConditionalEventsReport(filters: ConditionalEventsFilters) {
    return ApiService.post<ConditionalEventsReportDTO>(
      `${ReportService.ENDPOINT}/${ReportType.CONDITIONAL_EVENTS}`,
      filters,
    );
  }

  static getVehicleGeofenceReport(filters: VehicleGeofenceFilters) {
    return ApiService.post<VehicleGeofenceReportDTO>(
      `${ReportService.ENDPOINT}/${ReportType.GEOFENCES}`,
      filters,
    );
  }

  static getTripsReport(filters: TripsFilters) {
    return ApiService.post<TripsReportDTO>(
      `${ReportService.ENDPOINT}/${ReportType.TRIPS}`,
      filters,
    );
  }
}

export default ReportService;
